module.exports = __webpack_public_path__ + "img/xcx1.9b1eafd6.svg";